var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zpApiResponseContainer"},[_c(_vm.compiled,{tag:"component"}),(_vm.loading)?_c('div',{staticClass:"loading-spinner"},[_c('div',{staticClass:"spinner"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }